import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './image-link-v2.component.scss';
import * as Swiper from 'swiper/dist/js/swiper.js';
var ImageLinkV2 = /** @class */ (function (_super) {
    tslib_1.__extends(ImageLinkV2, _super);
    function ImageLinkV2(element) {
        return _super.call(this, element) || this;
    }
    ImageLinkV2.prototype.init = function () {
        this.smallSliderContainer = this.element.querySelector('.image-link-v2__carousel--swiper');
        this.smallSlider = new Swiper(this.smallSliderContainer, {
            slidesPerView: 1.2,
            centeredSlides: false,
            spaceBetween: 30,
            initialSlide: 0,
            breakpoints: {
                1201: {
                    initialSlide: 0,
                    slidesPerView: 4,
                    spaceBetween: 30,
                },
                1025: {
                    initialSlide: 0,
                    slidesPerView: 2.5,
                    spaceBetween: 30,
                },
                768: {
                    initialSlide: 0,
                    slidesPerView: 2,
                    spaceBetween: 30,
                },
                581: {
                    initialSlide: 0,
                    slidesPerView: 2,
                    spaceBetween: 10,
                },
                481: {
                    initialSlide: 0,
                    slidesPerView: 1.5,
                    spaceBetween: 10,
                }
            },
            freeMode: false,
            navigation: {
                nextEl: '.image-link-v2__carousel--container__rightarrow',
                prevEl: '.image-link-v2__carousel--container__leftarrow',
            }
        });
    };
    ImageLinkV2.prototype.bindEvents = function () {
    };
    return ImageLinkV2;
}(Base));
export { ImageLinkV2 };



//////////////////
// WEBPACK FOOTER
// ./components/image-link-v2/image-link-v2.component.ts
// module id = 775
// module chunks = 0